/*
 * Detect when zepto loads into page
 * Zepto engraving facade: opens the Zepto modal from our custom link
 *
 * ---------------------------------------------------------------
 * Modified by Stephen - October 1, 2026
 * Why: the "Add to Cart with Engraved Plaque" link was not working
 * on some product pages.
 *
 * Changes:
 *  1. Link click is attached right away instead of only after Zepto
 *     loads. The old script gave up after ~11 seconds, leaving the
 *     link dead on slower-loading pages.
 *  2. Script runs even if it loads after DOMContentLoaded has fired
 *     (old version could silently never run).
 *  3. Hidden Length / default-size fields are no longer duplicated
 *     each time the engraving popup is opened.
 *  4. No longer crashes on products without the custom-sizing field.

 *
 * Related files:
 *  - assets/detect-zepto-inline.js (inline engraving, e.g. 80308 Lucite)
 *  - assets/detect-zepto.css (styling, hides Zepto's real button)
 *  - Engraving link HTML: buy_buttons block in product page Liquid
 * ---------------------------------------------------------------
 */
(function () {
  function init() {
    console.log("Zepto engraving script started");

    // Wait for an element to appear (returns null after timeout)
    // Added by Stephen 10/1/2026 - replaces old 1-second polling loop
    function waitFor(selector, timeout) {
      return new Promise(function (resolve) {
        var found = document.querySelector(selector);
        if (found) return resolve(found);
        var obs = new MutationObserver(function () {
          var el = document.querySelector(selector);
          if (el) { obs.disconnect(); resolve(el); }
        });
        obs.observe(document.documentElement, { childList: true, subtree: true });
        setTimeout(function () {
          obs.disconnect();
          resolve(document.querySelector(selector));
        }, timeout || 15000);
      });
    }

    // Open Zepto's hidden blue button (the real engraving popup)
    // Modified by Stephen 10/1/2026 - waits for Zepto if it isn't loaded yet
    function openZepto() {
      waitFor('.btn.pplr-c-button', 15000).then(function (btn) {
        if (!btn) {
          console.warn('Zepto button not found on this product');
          return;
        }
        console.log("Zepto trigger clicked");
        btn.click(); // opens the Zepto modal
      });
    }

    // Bind sizing dropdown values to the Zepto add-to-cart form
    // Modified by Stephen 10/1/2026 - no duplicate fields, no crash if
    // the custom-sizing field is missing
    function bindZeptoFormToCart() {
      waitFor('.pplr_form.pplr_atc_form', 15000).then(function (form) {
        if (!form) return;

        // Selected cane length -> hidden "*Length*" property
        var lengthSelect = document.querySelector("[data-js='select-length']");
        if (lengthSelect) {
          var len = form.querySelector("input[name='properties[*Length*]']");
          if (!len) {
            len = document.createElement('input');
            len.type = 'hidden';
            len.setAttribute('name', 'properties[*Length*]');
            form.appendChild(len);
          }
          len.value = lengthSelect.value;
        } else {
          console.log('Cant find lengthSelect for engraving zepto form');
        }

        // Default cane size tag -> copied into Zepto form (only once)
        var def = document.querySelector("[name='properties[_CANE-DEFAULT-SIZE-TAG]']");
        if (def && !form.querySelector("[name='properties[_CANE-DEFAULT-SIZE-TAG]']")) {
          form.appendChild(def.cloneNode());
        }
      });
    }


    // One click listener for everything - works no matter when things load
    // Modified by Stephen 10/1/2026 - replaces the old per-element listeners
    document.addEventListener('click', function (e) {
      // CTA "Add to Cart with Engraved Plaque" link, or the
      // "Click here to add a custom engraving" link in the collapsible tab
      var trigger = e.target.closest('[data-js="zepto-trigger"], a[href="#open-zepto"]');
      if (trigger) {
        e.preventDefault();
        openZepto();
        return;
      }
      // Zepto blue button clicked (directly or by openZepto above)
      if (e.target.closest('.btn.pplr-c-button')) {
        bindZeptoFormToCart();
      }
    });
  }

  // Added by Stephen 10/1/2026 - run now if the page already finished loading
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();